import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/reportehistorialtanques';
import ReporteHistorialTanques from './ReporteHistorialTanques';


const ms2p = (state) => {
  return {
    ...state.rht,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ReporteHistorialTanques);
